import { STATUS } from '#constants/status';
import { STEPS_STATUS_IDS } from '#models/general/steps/constants';

export const mapAddSpirit = ({ spiritData = {}, spiritId = '' }) => [JSON.stringify(spiritData), spiritId];

export const mapUpdateSpiritStep = params => ({
  ...params?.spiritData,
  spiritChargedVolumeCharged: params?.spiritData?.LWFRVolume,
  [STEPS_STATUS_IDS.SPIRIT]: STATUS.COMPLETED
});
